<template>
  <div>
    <!-- <div class="mainTitle">试题答疑</div> -->
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="答疑状态" prop="state">
              <el-select
                v-model="searchForm.state"
                style="width:100%"
                clearable
                placeholder="请选择答疑状态"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="具体课程" prop="courseId">
              <el-cascader
                style="width:100%"
                :show-all-levels="false"
                ref="tree"
                @change="subjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                collapse-tags
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="关键词" prop="query">
              <el-input
                clearable
                v-model="searchForm.keywords"
                placeholder="请输入关键词"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="6">
            <el-form-item label="提问时间" prop="createTime">
              <el-date-picker
                style="width:100%"
                v-model="searchForm.createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <!-- <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="章节试卷" prop="chapterId">
              <el-select v-model="searchForm.chapterId" clearable placeholder="请选择章节试卷">
                <el-option
                  v-for="item in stateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->

          <el-col :sm="24" :md="24" :lg="6">
            <el-form-item label="回复时间" prop="replyTime" class="form-bottom">
              <el-date-picker
                style="width:100%"
                v-model="searchForm.replyTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="提问内容" prop="query">
              <el-input
                clearable
                v-model="searchForm.query"
                placeholder="请输入提问内容"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="回复人员" prop="replyUser">
              <el-input
                clearable
                v-model="searchForm.replyUser"
                placeholder="请输入回复人员"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="回复内容" prop="reply">
              <el-input
                clearable
                v-model="searchForm.reply"
                placeholder="请输入回复内容"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>-->

          <el-col :sm="24" :md="12" :lg="6" style="float:right">
            <el-button-group style="float:right">
              <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
              <!-- <a class="mainColor" @click="reset">清空</a> -->
              <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
            </el-button-group>
            <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <!-- <el-row :span="24">
        <el-col :span="12">
          <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
          <el-button type="danger" @click="batchDeleteQuestionQuery" icon="el-icon-minus">批量删除</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12"></el-col>
      </el-row>-->
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        v-loading="Loading"
        border
        @selection-change="selectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="state" width="100" label="答疑状态">
          <template slot-scope="scope">
            <div class="state">
              <span v-if="scope.row.state==0" style="background:rgb(255,185,28)">待解答</span>
              <span v-else-if="scope.row.state==1" style="background:rgb(36,210,181);">已解答</span>
              <span v-else-if="scope.row.state==-1" style="background:rgb(171, 179, 195);">已取消</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="subjectCourseName" width="240" label="科目课程"></el-table-column>
        <el-table-column show-overflow-tooltip prop="query" label="疑问内容">
          <template slot-scope="scope">
            <span class="mainColor" @click="goDetial(scope.row)">{{scope.row.query}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="studentMobile" label="学员"></el-table-column>
        <el-table-column show-overflow-tooltip prop="createTime" label="提问时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="reply" label="回答"></el-table-column>
        <el-table-column show-overflow-tooltip prop="replyUser" label="回复人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="replyTime" label="回复时间"></el-table-column>
        <!-- <el-table-column prop label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span @click="selection = scope.row.id, editFormVisible = true">编辑</span>
              <span @click="deleteQuestionQuery(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>-->
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" width="50%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules"></el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addQuestionQuery">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" width="50%" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      ></el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateQuestionQuery">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path == "/queryDetial") {
        vm.pageList();
      }
    });
  },
  data() {
    return {
      stateList: [
        {
          label: "已解答",
          value: "1"
        },
        {
          label: "待解答",
          value: "0"
        },
        {
          label: "已取消",
          value: "-1"
        }
      ],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true
      },
      addFormVisible: false,
      editFormVisible: false,
      Loading: false,
      searchForm: {
        courseIds: [],
        state: "",
        chapterId: "",
        query: "",
        createTime: "",
        replyUser: "",
        reply: "",
        replyTime: ""
      },
      addForm: {},
      addFormRules: {},
      editForm: {},
      editFormRules: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/questionQuery/upload`,
      fileList: [],
      loading: false
    };
  },
  methods: {
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    subjectChange(val) {
      this.searchForm.courseIds = [];
      val.forEach(item => {
        this.searchForm.courseIds.push(item[2]);
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getQuestionQuery() {
      this.api.questionQuery
        .getQuestionQuery({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.Loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.questionQuery
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.Loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addQuestionQuery() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.questionQuery
            .addQuestionQuery(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateQuestionQuery() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.questionQuery
            .updateQuestionQuery(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteQuestionQuery(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.questionQuery
            .deleteQuestionQuery([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    goDetial(row) {
      this.$router.push({
        path: "/queryDetial",
        query: {
          id: row.id
        }
      });
    },
    batchDeleteQuestionQuery() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.questionQuery
            .deleteQuestionQuery(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      let obj = {};
      try {
        this.$refs.tree.clearValue(obj);
      } catch (err) {
        this.$refs.tree.handleClear(obj);
      }
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    "searchForm.createTime": function(newVal) {
      this.searchForm.createTimeStart = newVal[0];
      this.searchForm.createTimeEnd = newVal[1];
    },
    "searchForm.replyTime": function(newVal) {
      this.searchForm.replyTimeStart = newVal[0];
      this.searchForm.replyTimeEnd = newVal[1];
    },
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getQuestionQuery();
      }
    }
  },
  mounted() {
    this.getSubjectTreeList();
    this.pageList();
  }
};
</script>
<style lang="less" scoped>
.state {
  text-align: center;
  span {
    padding: 4px 8px;
    color: #fff;
    border-radius: 4px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/questionQuery/index.vue